import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";
import { HOME_CAPABILITIES } from "../lib/site";

const CHIP_TONES = {
    "IN THE PILOT": "border-white/30 text-white/85",
    "IN DEVELOPMENT": "border-white/20 text-mist",
    PLANNED: "border-white/20 border-dashed text-cad",
};

const HomeCapabilities = () => (
    <section
        data-testid="home-capabilities-section"
        className="relative bg-surface/40 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    PLATFORM CAPABILITIES
                </p>
                <span className="h-px flex-1 bg-white/10" />
            </motion.div>

            <motion.h2
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="capabilities-home-headline"
                className="mt-12 max-w-4xl font-display text-4xl font-semibold leading-[1.1] text-white md:text-6xl"
            >
                One connected platform. Multiple construction insights
                <span className="text-accent">.</span>
            </motion.h2>

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3"
            >
                {HOME_CAPABILITIES.map((cap) => (
                    <motion.article
                        key={cap.id}
                        variants={fadeUp}
                        data-testid={`home-capability-${cap.id}`}
                        className="group flex flex-col border border-white/12 bg-surface/80"
                    >
                        <div className="relative overflow-hidden">
                            <img
                                src={cap.image}
                                alt={cap.alt}
                                loading="lazy"
                                className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                            />
                            <span
                                className={`absolute right-3 top-3 border bg-[#0A0F1D]/75 px-2 py-1 font-mono text-[13px] tracking-[0.18em] backdrop-blur-sm ${CHIP_TONES[cap.status]}`}
                            >
                                {cap.status}
                            </span>
                        </div>
                        <div className="flex flex-1 flex-col px-6 py-6">
                            <h3 className="font-display text-xl font-semibold text-white">
                                {cap.title}
                            </h3>
                            <p className="mt-3 flex-1 text-[15px] leading-relaxed text-mist">
                                {cap.copy}
                            </p>
                            <Link
                                to={cap.href}
                                data-testid={`home-capability-link-${cap.id}`}
                                className="mt-5 inline-flex items-center gap-1.5 text-[14px] font-semibold text-accent transition-colors duration-300 hover:text-[#ff7026]"
                            >
                                Learn more
                                <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                            </Link>
                        </div>
                    </motion.article>
                ))}
            </motion.div>
        </div>
    </section>
);

export default HomeCapabilities;
